export const BASE_SPACING = 8;

export default BASE_SPACING;
